export class UserVistaAuthentificate {
  UserId: string;
  UserFistName: string;
  UserLastName: string;
  UserEmail: string;
  UserSuperUser: boolean;
  UserManageUsers: boolean;
  UserAllBrands: boolean;
  UserAllCustomers: boolean;
  UserDisbled: boolean;
  UserLastUpdateUserId: string;
  UserLastUpdateDate: Date;
  UserPRGroup: boolean;
  marketCompanyId: number;
  UserVistaPermissionsId: number;
  MultipleMco: number;
  MarketCoMasterData: boolean;
  FinacialInformationData: boolean;
  EposInformationData: boolean;
  PromotionPlansData: boolean;
  AdvancedData: boolean;
  FinacialParameters: boolean;
  PromotionParameters: boolean;
  DailyRosFirstDayParameters: boolean;
  SeasonalitesParameters: boolean;
  AdvancedParameters: boolean;
  AdditionalParameters: boolean;
  Settings: boolean;
  EposManagementParameters: boolean;
  Monitoring: boolean;
  CoherencyTest: boolean;
}
